// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"eab18009","313":"ce40c16a","322":"ab05e74e","549":"7f636325"}[chunkId] + ".chunk.js";
};